export default __webpack_public_path__ + "static/media/17.afc0e0dd.png";